<template>
    <div class="px-3 flex-1 flex font-[CircularBook]">
        <div
            class="bg-[#f5f4f9] max-w-[1331px] w-full mx-auto rounded-[20px] overflow-hidden pt-10 pb-16 flex-1 flex items-center justify-center px-3">
            <div class="max-w-[1108px] w-full mx-auto">
                <div
                    class="bg-white rounded-[15px] sm:col-span-2 col-span-4 md:col-span-1 xl:col-span-2 overflow-hidden order-3 xl:order-1 mb-5">
                    <div class="border-b border-[#eeeff2] py-3 px-5 gap-2 flex flex-wrap items-center justify-center md:justify-between">
                        <div class="flex items-center gap-5">
                            <img class="btc-logo"
                                 :src="currencyIcons[`../../../public/img/coins/${currency.symbol.toLowerCase()}.svg`]?.default"
                                 alt="">
                            <span class="block text-[20px] md:text-[25px] font-[CircularBold]">Withdraw <span>{{
                                    currency.name
                                }}</span></span>
                        </div>
                        <button
                            class="max-w-[150px] w-full flex items-center justify-center gap-3 bg-[#366fed] hover:bg-[#5282eb] rounded-[5px] px-2 py-[.35em] md:mx-2 xl:mx-0"
                            id="add_address"
                            @click="addAddress"
                        >
                            <span
                                class="block text-[14px] text-white font-[CircularBook] tracking-wide">Add Address</span>
                        </button>
                    </div>


                    <div class="max-w-[600px] w-full mx-auto px-3">
                        <div v-if="!currency.canWithdraw">
                            Withdraw is disabled for this currency.
                        </div>

                        <div v-if="currency.canWithdraw">
                            <div class="my-2">
                                <p class="desc">Fill in the required fields for the withdraw request.</p>
                                <p class="attention desc"><span class="text-red-800">Attention:</span> Transfers to the
                                    wrong address cannot be recovered.</p>
                            </div>

                            <div class="mb-3">
                                <div class="flex">
                                <span
                                    class="text-[12px] font-[CircularBook] tracking-wide inline-flex items-center px-4 text-gray-900 border rounded-s-[7px] rounded-e-0 border-[#eeeff2] !border-r-0 bg-white">
                                    Address
                                </span>
                                    <select
                                        class="text-[14px] text-[#2a395a] rounded-none rounded-e-lg bg-white border !border-l-0 block flex-1 min-w-0 w-full text-sm border-[#eeeff2] py-[1.35em] pe-[1.5em] placeholder:text-[14px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook] placeholder:tracking-wide"
                                        name="address"
                                        id="address"
                                        v-model="withdrawAddressId"
                                    >
                                        <option
                                            v-for="address in addresses"
                                            :value="address.id"
                                            :disabled="address.chain !== withdrawChain"
                                        >
                                            {{ address.chain }} - {{ address.label }} -- {{ address.address }}
                                            {{ address.memo ? "memo: " + address.memo : "" }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="flex">
                                <span
                                    class="text-[12px] font-[CircularBook] tracking-wide inline-flex items-center px-4 text-gray-900 border rounded-s-[7px] rounded-e-0 border-[#eeeff2] !border-r-0 bg-white">
                                    {{ currency.symbol }}
                                </span>
                                    <input
                                        type="number"
                                        name="amount"
                                        class="text-[14px] text-[#2a395a] rounded-none rounded-e-lg bg-white border !border-l-0 block flex-1 min-w-0 w-full text-sm border-[#eeeff2] py-[1.35em] pe-[1.5em] placeholder:text-[14px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook] placeholder:tracking-wide"
                                        id="amount"
                                        v-model="withdrawAmount"
                                        placeholder="Amount"
                                    >
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="flex">
                                <span
                                    class="text-[12px] font-[CircularBook] tracking-wide inline-flex items-center px-4 text-gray-900 border rounded-s-[7px] rounded-e-0 border-[#eeeff2] !border-r-0 bg-white">
                                    Chain
                                </span>
                                    <select
                                        class="text-[14px] text-[#2a395a] rounded-none rounded-e-lg bg-white border !border-l-0 block flex-1 min-w-0 w-full text-sm border-[#eeeff2] py-[1.35em] pe-[1.5em] placeholder:text-[14px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook] placeholder:tracking-wide"
                                        name="chain"
                                        id="chain"
                                        v-model="withdrawChain"
                                    >
                                        <option
                                            v-for="chain in chains"
                                            :value="chain"
                                        >
                                            {{ chain }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="flex flex-column justify-center items-center">
                                <div class="min-max">Your balance: <span role="button" id="max-withdraw-value">{{
                                        wallet.balance
                                    }} {{ wallet.currency_code }}</span></div>
                                <div class="min-max mt-4">Min. Withdraw: <span class="min">{{
                                        currency.minWithdrawal
                                    }}</span> {{ currency.symbol }}
                                </div>
                                <div class="min-max">Max. Withdraw: <span class="max">{{
                                        currency.maxWithdrawal
                                    }}</span> {{ currency.symbol }}
                                </div>
                                <p class="wth-fee">Withdraw Fee: <span class="fee">{{ currency.fee }}</span>
                                    {{ currency.symbol }}</p>

                                <button
                                    class="block w-full gap-[17px] bg-[#366fed] hover:bg-[#5282eb] rounded-[10px] py-2 md:mx-2 xl:mx-0 text-white my-4"
                                    @click="submitWithdraw"
                                >
                                    Withdraw
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="modal fade" id="confirmWithdraw" tabindex="-1" role="dialog" aria-labelledby="confirmWithdrawLabel"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content bg-white rounded-2xl shadow-xl max-w-md w-full p-2">
                <div class="modal-body">
                    <div class="inner-modal">
                        <div class="flex justify-center mb-6">
                            <div class="bg-blue-100 rounded-full p-4">
                                <img
                                    :src="currencyIcons[`../../../public/img/coins/${currency.symbol.toLowerCase()}.svg`]?.default"
                                    alt="" class="withdraw-currency">
                            </div>
                        </div>

                        <h2 class="text-2xl font-bold text-gray-900 text-center mb-2">Confirm Withdrawal</h2>
                        <p class="text-gray-500 text-center mb-4 text-sm">Please review the details below</p>

                        <div class="bg-[#f5f4f9] rounded-xl p-6 mb-6">
                            <p class="text-sm text-gray-600 mb-1">Withdrawal Amount</p>
                            <p class="text-3xl font-bold text-gray-900">{{ withdrawAmount }} {{ currency.symbol }}</p>
                        </div>

                        <div class="space-y-4 mb-6">
                            <div class="flex justify-between items-start pb-4 border-b border-gray-100">
                                <span class="text-sm text-gray-600">Address</span>
                                <div class="text-right max-w-[60%]">
                                    <p class="text-sm font-mono text-gray-900 break-all">{{ withdrawAddress }}</p>
                                </div>
                            </div>

                            <div class="flex justify-between items-center pb-4 border-b border-gray-100">
                                <span class="text-sm text-gray-600">Transaction Fee</span>
                                <span class="text-sm font-semibold text-gray-900">{{ withdrawFee }} {{
                                        currency.symbol
                                    }}</span>
                            </div>
                            <div v-if="isInternal"
                                 class="flex justify-between items-center pb-4 border-b border-gray-100">
                                <span class="text-sm text-gray-600">Since recipient is internal, fee is 0.</span>
                            </div>

                            <div class="flex justify-between items-center">
                                <span class="text-sm font-semibold text-gray-900">You Get</span>
                                <span class="text-lg font-bold text-green-600">{{
                                        withdrawReceiveAmount
                                    }} {{ currency.symbol }}</span>
                            </div>
                        </div>

                        <div class="mb-6">
                            <label class="block text-sm font-medium text-gray-700 mb-2">Two Factor
                                Authentication</label>
                            <input
                                v-model="twoFaSecret"
                                type="text"
                                placeholder="Enter 6-digit code"
                                maxlength="6"
                                class="w-full font-[CircularBook] border text-sm border-[#eeeff2] text-[14px] text-[#2a395a] rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition text-center py-[1.35em] pe-[1.5em] placeholder:text-[14px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook] placeholder:tracking-wide tracking-widest"
                            >
                        </div>
                        <div class="flex gap-3">
                            <button data-dismiss="modal"
                                    class="flex-1 rounded-[10px] py-2 md:mx-2 xl:mx-0 border border-gray-300 text-gray-700 font-semibold hover:bg-gray-50 transition">
                                Cancel
                            </button>
                            <button @click="confirmWithdraw"
                                    class="flex-1 rounded-[10px] py-2 md:mx-2 xl:mx-0 text-white bg-[#366fed] hover:bg-[#5282eb] font-semibold transition shadow-lg shadow-blue-500/30">
                                Confirm
                            </button>
                        </div>

                        <div class="mt-6 flex items-start gap-2 bg-amber-50 p-3 rounded-lg border border-amber-200">
                            <svg class="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor"
                                 viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                            </svg>
                            <p class="text-xs text-amber-800">Please verify all details before confirming. This action
                                cannot be undone.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {ref, watch} from "vue"
import Swal from "sweetalert2";
import {isNegative, isZero} from "mathjs";

const wallet = window.wallet
const currency = window.currency
const addresses = window.addresses
const chains = window.chains
const withdrawAmount = ref(0.00000000)
const withdrawAddress = ref("")
const withdrawAddressId = ref("")
const withdrawFee = ref(0.00000000)
const withdrawReceiveAmount = ref(0.00000000)
const withdrawChain = ref(chains[0] ?? '');
const isInternal = ref(false)
const twoFaSecret = ref("")
const currencyIcons = import.meta.glob("../../../public/img/coins/*.svg", {eager: true})

watch(withdrawChain, (newChain) => {
    if (withdrawAddressId.value) {
        const selectedAddress = addresses.find(item => item.id === withdrawAddressId.value);
        if (selectedAddress && selectedAddress.chain !== newChain) {
            withdrawAddressId.value = "";
        }
    }
});

const addAddress = (e) => {
    e.preventDefault();
    createAddress(currency.symbol, chains).then(r => {
        axios.post("/financial/withdraw/address/add", {
            label: r.label,
            address: r.address,
            chain: r.chain,
            currency: currency.symbol,
            memo: r.memo
        })
            .then(({data}) => {
                Swal.fire({
                    title: 'Success',
                    icon: 'success',
                    text: data.data.message,
                });

                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            })
            .catch(({response: {data}}) => {
                let html = `<ul class="text-left">`;
                if (data.data.errors) {
                    data.data.errors.forEach((value) => {
                        html += `<li>${value}</li>`;
                    });
                } else {
                    html += `<li>${data.data.message}</li>`;
                }

                Swal.fire({
                    icon: "error",
                    title: "Error",
                    html: html
                });
            });
    });
}

const createAddress = async (currency, chains) => {
    let htmlInputs;

    const chainHtml = chains.map((item) => (
        `<option value="${item}">${item}</option>`
    ))

    const chainInputHtml = `<div class="flex mb-3">
                    <span class="text-[12px] font-[CircularBook] tracking-wide align-content-center w-[100px] text-gray-900 border rounded-s-[7px] rounded-e-0 border-[#eeeff2] !border-r-0 bg-white"> Chain* </span>
                    <select
                        id="swal-input-chain"
                        name="chain"
                        class="text-[14px] rounded-none rounded-e-lg bg-white border !border-l-0 block flex-1 min-w-0 w-full text-sm border-[#eeeff2] py-[1.35em] pe-[1.5em] appearance-none font-[CircularBook] tracking-wide text-[#a4a6aa] data-[empty=false]:text-[#2a395a]"
                        onchange="this.dataset.empty = this.value === ''"
                        >
                        <option value="" disabled selected>Chain*</option>
                        ` + chainHtml + `
                    </select>
                </div>`;

    switch (currency) {
        case ('XRP'):
            htmlInputs = `
                <div class="flex mb-3">
                    <span class="text-[12px] font-[CircularBook] tracking-wide align-content-center w-[100px] text-gray-900 border rounded-s-[7px] rounded-e-0 border-[#eeeff2] !border-r-0 bg-white"> Label* </span>
                    <input id="swal-input-label" placeholder="Label*" name="label" type="text" class="text-[14px] text-[#2a395a] rounded-none rounded-e-lg bg-white border !border-l-0 block flex-1 min-w-0 w-full text-sm border-[#eeeff2] py-[1.35em] pe-[1.5em] placeholder:text-[14px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook] placeholder:tracking-wide">
                </div>
                ` + chainInputHtml + `
                <div class="flex mb-3">
                    <span class="text-[12px] font-[CircularBook] tracking-wide align-content-center w-[100px] text-gray-900 border rounded-s-[7px] rounded-e-0 border-[#eeeff2] !border-r-0 bg-white">Address*</span>
                    <input id="swal-input-address" placeholder="Address*" name="address" type="text" class="text-[14px] text-[#2a395a] rounded-none rounded-e-lg bg-white border !border-l-0 block flex-1 min-w-0 w-full text-sm border-[#eeeff2] py-[1.35em] pe-[1.5em] placeholder:text-[14px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook] placeholder:tracking-wide">
                </div>
                <div class="flex">
                    <span class="text-[12px] font-[CircularBook] tracking-wide align-content-center w-[100px] text-gray-900 border rounded-s-[7px] rounded-e-0 border-[#eeeff2] !border-r-0 bg-white">Memo*</span>
                    <input id="swal-input-memo" placeholder="Memo*" name="memo" type="text" class="text-[14px] text-[#2a395a] rounded-none rounded-e-lg bg-white border !border-l-0 block flex-1 min-w-0 w-full text-sm border-[#eeeff2] py-[1.35em] pe-[1.5em] placeholder:text-[14px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook] placeholder:tracking-wide">
                </div>
            `;
            break;

        default:
            htmlInputs = `
                <div class="flex mb-3">
                    <span class="text-[12px] font-[CircularBook] tracking-wide align-content-center w-[100px] text-gray-900 border rounded-s-[7px] rounded-e-0 border-[#eeeff2] !border-r-0 bg-white"> Label* </span>
                    <input id="swal-input-label" placeholder="Label*" name="label" type="text" class="text-[14px] text-[#2a395a] rounded-none rounded-e-lg bg-white border !border-l-0 block flex-1 min-w-0 w-full text-sm border-[#eeeff2] py-[1.35em] pe-[1.5em] placeholder:text-[14px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook] placeholder:tracking-wide">
                </div>
                ` + chainInputHtml + `
                <div class="flex">
                    <span class="text-[12px] font-[CircularBook] tracking-wide align-content-center w-[100px] text-gray-900 border rounded-s-[7px] rounded-e-0 border-[#eeeff2] !border-r-0 bg-white">Address*</span>
                    <input id="swal-input-address" placeholder="Address*" name="address" type="text" class="text-[14px] text-[#2a395a] rounded-none rounded-e-lg bg-white border !border-l-0 block flex-1 min-w-0 w-full text-sm border-[#eeeff2] py-[1.35em] pe-[1.5em] placeholder:text-[14px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook] placeholder:tracking-wide">
                </div>
`;
            break;
    }

    const {value: formValues} = await Swal.fire({
        title: 'Save new withdraw address',
        html: htmlInputs,
        focusConfirm: false,
        customClass: {
            confirmButton: 'block w-full gap-[17px] bg-[#366fed] hover:bg-[#5282eb] rounded-[10px] md:mx-2 xl:mx-0 text-white font-[CircularBook]',
        },
        preConfirm: () => {

            let returnObject = {};

            switch (currency) {
                case ('XRP'):
                    return {
                        "label": $('#swal-input-label').val(),
                        "chain": $('#swal-input-chain').val(),
                        "address": $('#swal-input-address').val(),
                        "memo": $('#swal-input-memo').val()
                    };

                default:
                    return {
                        "label": $('#swal-input-label').val(),
                        "chain": $('#swal-input-chain').val(),
                        "address": $('#swal-input-address').val(),
                    }
            }
        }
    })

    return formValues;
}

const submitWithdraw = () => {
    if (isNegative(withdrawAmount.value) || isZero(withdrawAmount.value)) {
        Swal.fire('Warning!', 'The amount must be greater than 0.', 'warning')
        return;
    }

    if (!withdrawAddressId.value || withdrawAddressId.value === '') {
        Swal.fire('Warning!', 'Please select a withdraw address.', 'warning')
        return;
    }

    axios.post("/financial/withdraw/validate", {
        currency: currency.symbol,
        amount: withdrawAmount.value,
        address: withdrawAddressId.value,
        chain: withdrawChain.value
    }).then(({data: {data}}) => {
        withdrawAddress.value = data.recipient
        withdrawFee.value = data.fee
        withdrawReceiveAmount.value = data.receivingAmount
        withdrawAmount.value = data.amount
        isInternal.value = data.isInternal;

        $('#confirmWithdraw').modal('show');
    }).catch(({response: {data}}) => {
        Swal.fire('Warning!', data.data.message, 'warning');
    });
}

const confirmWithdraw = () => {
    const memo = $(`input[name="memo"]`).val();

    if (isNegative(withdrawAmount.value) || isZero(withdrawAmount.value)) {
        Swal.fire('Warning!', 'The amount must be greater than 0.', 'warning')
        return;
    }

    if (withdrawAddressId.value === '') {
        Swal.fire('Warning!', 'Please select a withdraw address.', 'warning')
        return;
    }

    if (!twoFaSecret.value || twoFaSecret.value === '') {
        Swal.fire('Warning!', 'Please complete the 2FA Verification Code.', 'warning')
        return;
    }

    axios.post("/financial/withdraw/generate", {
        currency: currency.symbol,
        chain: withdrawChain.value,
        amount: withdrawAmount.value,
        address: withdrawAddressId.value,
        secret: twoFaSecret.value,
        memo
    }).then(({data}) => {
        Swal.fire('Success!', data.data.message, 'success');
        $('#confirmWithdraw').modal('hide');

    }).catch(({response: {data}}) => {
        Swal.fire('Warning!', data.data.message, 'warning');
    });
}

</script>
